import { ErrorToaster } from './toaster';

export const FormatPhoneNumber = (value) => {
  if (!value) return value;

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const EMAIL_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

export const isValidEmailFormat = (value) => typeof value === 'string' && EMAIL_REGEX.test(value);

export const EmailValidator = (value) => {
  if (!isValidEmailFormat(value)) {
    ErrorToaster('Enter valid Email');
    return true;
  }
}

export const PhoneValidator = (value) => {
  if (value?.length !== 14) {
    ErrorToaster('Enter a valid Phone Number');
    return true;
  }
}

export const EmptyStringCheck = (value, message) => {
  if (value === '' || value === undefined || value === null) {
    ErrorToaster(message);
    return true;
  }
}

export const customToaster = (message) => {

  ErrorToaster(message);
  return true;

}

export const extractNumbersFromString = (inputString) => {
  console.log(inputString,'inputString')
  const regex = /\d+/g;
  const numbersArray = inputString?.match(regex);
  return numbersArray ? numbersArray?.map(Number) : [];
};

export const GetDateFromHours = (time) => {
  time = time?.split(':') || [];
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
}

export const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()

const EMOJI_PATTERN = '\\p{Extended_Pictographic}|\\p{Emoji_Presentation}|[\\u{1F1E6}-\\u{1F1FF}]|[\\u{200D}\\u{FE0F}\\u{20E3}]';

export const stripEmoji = (value) => {
  if (typeof value !== 'string' || !value) return value;
  return value.replace(new RegExp(EMOJI_PATTERN, 'gu'), '');
}

export const containsEmoji = (value) => typeof value === 'string' && new RegExp(EMOJI_PATTERN, 'u').test(value);

// Strips any run of leading characters that aren't letters/digits (special chars, symbols,
// stray emoji, whitespace), so a field can't start with anything but alphanumeric text.
// A single leading '$' is allowed through (currency/amount fields render as "$1,234").
export const stripLeadingSpecialChars = (value) => {
  if (typeof value !== 'string' || !value) return value;
  const hasLeadingDollar = value[0] === '$';
  const rest = hasLeadingDollar ? value.slice(1) : value;
  const cleanedRest = rest.replace(/^[^a-zA-Z0-9]+/, '');
  return hasLeadingDollar ? '$' + cleanedRest : cleanedRest;
}

// Strips any run of trailing characters that aren't letters/digits. Deliberately NOT applied
// on every keystroke (unlike stripLeadingSpecialChars) - the last character typed is always
// "trailing" for a split second, so live-stripping it would make it impossible to type interior
// punctuation like "Main St, Suite 4" or "O'Brien & Sons, Inc." while continuing to type after
// it. This is meant to run once editing is done (e.g. on blur).
// Stops before a trailing ')' that closes an earlier unmatched '(' (e.g. "Timesheet (229217-3)"),
// so legitimate parenthetical labels don't lose their closing paren on blur.
export const stripTrailingSpecialChars = (value) => {
  if (typeof value !== 'string' || !value) return value;
  let end = value.length;
  while (end > 0 && !/[a-zA-Z0-9]/.test(value[end - 1])) {
    if (value[end - 1] === ')') {
      const prefix = value.slice(0, end - 1);
      const opens = (prefix.match(/\(/g) || []).length;
      const closes = (prefix.match(/\)/g) || []).length;
      if (opens > closes) break;
    }
    end--;
  }
  return value.slice(0, end);
}

// encodeURIComponent leaves !'()* unescaped (they're "safe" per JS's rules), but S3/SigV4 only
// treat A-Z a-z 0-9 - _ . ~ as safe - everything else, including those five, must be
// percent-encoded or S3 can reject the request. This closes that gap on top of encodeURIComponent.
const strictUriEncode = (value) =>
  encodeURIComponent(value).replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());

// Encodes only the filename (last path segment) of a file URL, leaving the origin/folder path
// and any query string untouched. Reserved characters left raw in a URL (#, %, ?, &, unencoded
// spaces, parentheses, etc.) get misparsed by the browser as a fragment/query separator before
// the request even reaches S3, so this at least makes the request well-formed. Decodes first so
// an already-encoded segment isn't double-encoded; falls back to the raw name if it isn't
// validly encoded (e.g. a literal '%' in the filename).
export const encodeFileUrlPath = (url) => {
  if (typeof url !== 'string' || !url) return url;
  const [path, query] = url.split('?');
  const segments = path.split('/');
  const rawFileName = segments.pop();
  let decoded = rawFileName;
  try {
    decoded = decodeURIComponent(rawFileName);
  } catch (e) {
    // rawFileName isn't validly encoded (e.g. a lone '%') - use it as-is
  }
  segments.push(strictUriEncode(decoded));
  const encodedPath = segments.join('/');
  return query ? `${encodedPath}?${query}` : encodedPath;
}

export const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const siteTimeZone = () => { return sessionStorage.getItem('siteTimeZone') !== 'undefined' ? sessionStorage.getItem('siteTimeZone') : Intl.DateTimeFormat().resolvedOptions().timeZone }

export const timeZoneAbbreviation = () => {
  let timezoneName = sessionStorage.getItem('timeZoneAbbreviation');
  return (timezoneName === 'null' || timezoneName === 'undefined') ? '' : sessionStorage.getItem('timeZoneAbbreviation');
}

console.log(timeZoneAbbreviation, siteTimeZone)
// export const corsUrl = 'https://app.mytimesmart.com/cors/'

export const corsUrl = 'https://app.timesmartai.com/cors/'